import SuperFetch from '../../../superFetch.js';

class RecommendEventApi {
  /**
   *  [추천 기획전 리스트] 추천 기획전 리스트 요청하기
   */
  getRecommendEventList = (data) => SuperFetch.post('/recommend/event/list', data);

  /**
   *  [추천 기획전 상세] 추천 기획전 상세 요청하기
   */
  getRecommendEventDetail = (data) => SuperFetch.post('/recommend/event/detail', data);

  /**
   *  [추천 기획전 복사] 추천 기획전 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendEvent = (data) => SuperFetch.post('/recommend/event/insert/preparation/copy', data);

  /**
   *   추천 기획전 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendEvent = (data) => SuperFetch.post('/recommend/event/insert/preparation/insert', data);

  /**
   *  [추천 기획전 복사] 추천 기획전에 연결할 아이템 리스트 요청하기
   */
  getRecommendEventItemList = (data) => SuperFetch.post('/recommend/event/insert/preparation/list', data);

  /**
   *  [추천 기획전 복사] 추천 기획전 등록/복사하기
   */
  createRecommendEvent = (data) => SuperFetch.post('/recommend/event/insert', data);

  /**
   *  [추천 기획전 복사] 전체 기획전 리스트 EXCEL 다운로드
   */
  getRecommendEventItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/event/insert/preparation/list/excel/download', data);

  /**
   *  [추천 기획전 복사] 선택된 기획전 리스트 EXCEL 다운로드
   */
  getSelectedRecommendEventItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/event/insert/preparation/list/excel/download/selected', data);

  /**
   *  [추천 기획전 복사] 기획전 리스트 EXCEL 업로드
   */
  setRecommendEventItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/event/insert/preparation/list/excel/upload', data);
}

export default new RecommendEventApi();
